(function () {
    App.controller('LifeSalariedCtrl', lifeSalariedController);

    lifeSalariedController.$inject = ['$scope', '$rootScope', '$sce', '$state', '$http', 'packageService', '$stateParams', 'profileService', 'statesService', 'branchService', '$q', '$filter', '$timeout', '$anchorScroll', '$location', '$mdDialog', 'Config'];

    function lifeSalariedController($scope, $rootScope, $sce, $state, $http, packageService, $stateParams, profileService, statesService, branchService, $q, $filter, $timeout, $anchorScroll, $location, $mdDialog, Config) {
        $scope.stateParams = $stateParams;

        $scope.maxDate = new Date();

        $scope.page = 'life';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Wybierz wariant ubezpieczenia dla siebie i najbliższych (krok 2)';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.life.variant';
        $scope.$emit('link', $scope.link);


        if ($scope.stateParams.choose && $scope.stateParams.prices) {
            $scope.person = $scope.stateParams.person;
            $scope.persons = $scope.stateParams.persons;
            $scope.choose = $scope.stateParams.choose;
            $scope.prices = $scope.stateParams.prices;
            $scope.partner = $scope.stateParams.partner;
            $scope.assured = $scope.stateParams.assured;
            $scope.summary = $scope.stateParams.summary;
            $scope.isAssured = {
                value: $scope.stateParams.isAssured
            };
            $scope.isPartner = $scope.stateParams.isPartner;
        } else {
            $state.go('root.life.start');
            return;
        }

        var userObject = window.sessionStorage.getItem('userObject');
        if (userObject) {
            $scope.userObject = JSON.parse(userObject);
            let branch = $scope.userObject.branch;
            if (branch && ((branch.company.id === 7 && branch.name === 'Cargo') || (branch.company.id === 7 && branch.name === 'CargoTabor'))) {
                $scope.showPopUp('', '', 'Aby przystąpić do programu grupowego ubezpieczenia na życie musisz uzupełnić oddział spółki oraz numer kadrowy w swoim Koncie Użytkownika.');
                $state.go('root.home.profile');
            }
            var userObjectCopy = angular.copy($scope.userObject);
            $scope.person = angular.merge(userObjectCopy.person, {
                address: ($scope.person ? $scope.person.address : {}) || {}
            });
            $scope.person.branch = userObjectCopy.branch;
            $scope.person.employmentDate = userObjectCopy.employmentDate;

            if (userObjectCopy.employmentDetails) {
                let employmentDetails = userObjectCopy.employmentDetails;
                if (employmentDetails.employmentDate) {
                    $scope.person.employmentDate = employmentDetails.employmentDate;
                }
                if (employmentDetails.formOfEmployment) {
                    $scope.person.formOfEmployment = employmentDetails.formOfEmployment;
                    if (employmentDetails.formOfEmployment === 'OTHER') {
                        $scope.person.otherFormOfEmployment = employmentDetails.otherFormOfEmployment;
                    }
                } else {
                    $scope.person.formOfEmployment = 'CONTRACT_OF_EMPLOYMENT';
                    $scope.person.otherFormOfEmployment = null;
                }
            }

            if (!$scope.userObject.person.citizenshipType) {
                $scope.person.citizenshipType = $scope.person.identifierType === 'PESEL' ? 'POLISH' : 'OTHER';
            }

            if ($scope.userObject.person.citizenshipType !== 'POLISH') {
                $scope.person.gender = 'FEMALE';
            }

            if ($scope.stateParams.person && $scope.stateParams.person.employmentDate) {
                $scope.person.employmentDate = new Date($scope.stateParams.person.employmentDate);
            }
        } else if (!$scope.person) {
            $scope.person.citizenshipType = 'POLISH';
        }

        $scope.realDeclarationsNumber = 0;

        $scope.fields = [{
            "name": "Śmierć ubezpieczonego"
        },
            {
                "name": "Śmierć w następstwie NW"
            },
            {
                "name": "Zgon ubezpieczonego spowodowany długim zdaniem, które nie mieści się w jenej linijce"
            }
        ];

        $scope.isLifePackageHidden = function (person, group, item) {
            return person > 0 && $scope.lifePackages[group].disabledForFamilyMembers;
        };

        packageService.dataLifeList().then(function (data) {

            $scope.lifePackages = data.data.group;

        });

        if (!$scope.partner) {
            $scope.partner = {
                citizenshipType: 'POLISH',
                gender: "FEMALE",
                birthdate: null
            };
        }
        if (!$scope.assured) {
            $scope.assured = [{
                type: 'PERSON',
                country: 'POLISH',
                personBirthdate: null,
                sameAddress: true,
                city: $scope.person.address.city,
                street: $scope.person.address.street,
                number: $scope.person.address.number,
                apartment: $scope.person.address.apartment,
                zipCode: $scope.person.address.zipCode
            }];
        }


        $scope.addAssured = function () {
            if ($scope.assured.length < 4) {
                $scope.assured.push({
                    type: 'PERSON',
                    country: 'POLISH',
                    personBirthdate: null,
                    sameAddress: true,
                    city: $scope.person.address.city,
                    street: $scope.person.address.street,
                    number: $scope.person.address.number,
                    apartment: $scope.person.address.apartment,
                    zipCode: $scope.person.address.zipCode
                });
            }
        };

        $scope.deleteAssured = function (obj) {
            $scope.assured.splice(obj, 1);
        };

        $scope.accept = function () {
            console.log('accept',$scope.form, $scope.person);
            $scope.form.$setSubmitted();
            $scope.next($scope.form);
        };

        $scope.next = function () {
            var vm = this;

            if (!vm.form.$valid) {
                $scope.showPopUp('', 'Uzupełnij pola', 'Aby przejść dalej wypełnij wszystkie wymagane pola.', '');
                return 0;
            }
            if (!Object.keys($scope.choose[0]).length) {
                if (Object.keys($scope.choose[1]).length || Object.keys($scope.choose[2]).length) {
                    $scope.showPopUp('', 'Dokonaj wyboru wariantu ubezpieczenia', 'Aby zgłosić do ubezpieczenia Współmałżonka/Partnera i/lub Pełnoletnie dziecko, należy najpierw wybrać wariant ubezpieczenia dla Pracownika.');
                } else {
                    $scope.showPopUp('', 'Dokonaj wyboru wariantu ubezpieczenia', 'Aby kontynuować zaznacz minimum jeden wariant dla pracownika.');
                }
                return 0;
            }

            if (!$scope.notCheckValidAge) {
                var userObject = JSON.parse(window.sessionStorage.getItem('userObject'));
                if (userObject) {
                    if (!validateAge(userObject.person)) return;
                }
            }

            var isPercentageValid = $filter('percentageOfBenefit')($scope.isAssured.value ? $scope.assured : []);
            if (!isPercentageValid) {
                $scope.showPopUp('', 'Nieprawidłowy procent świadczenia', 'Procent świadczenia dla wszystkich uposażonych musi się sumować do 100%');
                return;
            }

            var params = {
                choose: $scope.choose,
                prices: $scope.prices,
                summary: $scope.summary,
                assured: $scope.assured,
                partner: $scope.partner,
                person: $scope.person,
                persons: $scope.persons,
                isAssured: $scope.isAssured.value,
                isPartner: $scope.isPartner
            };

            params.person.employmentDate = $filter('getDateFromBirthdate')($scope.person.employmentDate);

            if ($scope.realDeclarationsNumber > 1) {
                $state.go('root.life.data', params);
            } else {
                $state.go('root.life.confirmation', params);
            }
        };

        var getResults = function (query) {
            var deferred = $q.defer();

            statesService.dataCityLists({
                name: query
            }).then(function (data) {
                deferred.resolve(data.data);
            });

            return deferred.promise;
        };

        // ##### LOCALIZATION FILTER ##### //
        $scope.querySearchLocalization = function (query) {
            if (!query) {
                return;
            }

            return getResults(query).then(function (results) {
                return results;
            });
        };


        branchService.dataBranchLists().then(function (data) {
            $scope.branch = $filter('hideBranchCargo')(data.data.data)
        });

        // ##### FILTER ##### //
        $scope.querySearchBranch = function (query) {
            var results = query ? $scope.branch.filter(createFilterForItem(query)) : $scope.branch;
            return results;
        };

        function createFilterForItem(query) {
            var lowercaseQuery = angular.lowercase(query);

            return function filterFn(items) {
                return (angular.lowercase(items.name).indexOf(lowercaseQuery) !== -1);
            };
        }

        $scope.differentDates = function (value, birthDate) {
            return !moment(birthDate).isSame(value, 'day');
        };

        /**
         * Scroll to inputs on init;
         */
        (function () {
            $timeout(function () {
                // Always scroll by 70 extra pixels (navbar height)
                $anchorScroll.yOffset = 70;
                $location.hash('form');
            });
        })();

        $scope.showPopUp = function (ev, head, content, text, target, notClose, nextStep) {
            $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
                targetEvent: ev,
                clickOutsideToClose: !notClose,
                locals: {
                    head: head,
                    content: content,
                    button: {
                        text: text,
                        target: target
                    },
                    notClose: !notClose,
                    nextStep: nextStep
                }
            }).then(function (data) {
                if (data.confirm && data.nextStep) {
                    $scope.notCheckValidAge = true;
                    $scope.next();
                }
            }, function () {

            });
        };

        function PopUpInfoCtrl($scope, $mdDialog, locals) {
            $scope.locals = locals;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.confirm = function () {
                $scope.locals.confirm = true;
                $mdDialog.hide($scope.locals);
            };
        }
        PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals']

        function validateAge(person) {
            if (person.citizenshipType === 'POLISH') {
                if ($filter('isOver75FromIdentifier')(person.identifier)) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                    return 0;
                }

            } else {
                if ($filter('isOver75FromBirthdate')(new Date(person.birthdate))) {
                    $scope.showPopUp('', 'Informacja', 'Do ubezpieczenia mogą przystąpić osoby, które nie ukończyły 75 lat.', 'Wróć do strony głównej', 'root.dashboard', true);
                    return 0;
                }
            }
            return 1;
        }

        $scope.$watch('person', function (oldVal, newVal) {
            // console.log(oldVal, newVal);
            if (oldVal !== newVal) {
                for (var a = 0; a < $scope.assured.length; a++) {
                    if ($scope.assured[a].sameAddress) {
                        $scope.assured[a].city = $scope.person.address.city;
                        $scope.assured[a].street = $scope.person.address.street;
                        $scope.assured[a].number = $scope.person.address.number;
                        $scope.assured[a].apartment = $scope.person.address.apartment;
                        $scope.assured[a].zipCode = $scope.person.address.zipCode;
                    }
                }
            }
        }, true);

        $scope.$watch('assured', function (oldVal, newVal) {
            if (oldVal !== newVal) {
                for (var a = 0; a < $scope.assured.length; a++) {
                    if ($scope.assured[a].type !== 'ORGANIZATION' && $scope.assured[a].sameAddress) {
                        $scope.assured[a].city = $scope.person.address.city;
                        $scope.assured[a].street = $scope.person.address.street;
                        $scope.assured[a].number = $scope.person.address.number;
                        $scope.assured[a].apartment = $scope.person.address.apartment;
                        $scope.assured[a].zipCode = $scope.person.address.zipCode;
                    }
                }
            }
        }, true);
    }
})();
